/*
* Copyright(c) 2018. Synergy Systems & Solutions. @link : http://s3india.com 
*
* @module : PlayAgain
* @file : PlayAgain.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of PlayAgain
*
* Created on : 24-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 24-Oct-2019
*/
import React from 'react';
import {Link,Redirect} from 'react-router-dom';
import PlayAgainService from '../../services/PlayAgainService/PlayAgainService';
import Translation from '../../language/Translation';

class PlayAgain extends React.Component
{
	constructor(props)
	{
		super(props);
		this.translation = new Translation();
		this.state = {
			redirect: 0,
			translation:{
				'play_again_v1':this.translation.getText('play_again_v1'),
				'play_again_v2':this.translation.getText('play_again_v2'),
				'play_again_v3':this.translation.getText('play_again_v3'),
				'play_again_v4':this.translation.getText('play_again_v4')
			}
		}
		this.playAgainService = new PlayAgainService();
		this.confirmPlayAgain = this.confirmPlayAgain.bind(this);
		this.renderRedirect = this.renderRedirect.bind(this);
	}

	componentDidMount()
	{
	}

	confirmPlayAgain(e)
	{
		let dataValue = e.currentTarget.getAttribute('data-value');
		if(dataValue==='yes')
		{
			this.setState({redirect:1});
		}
		else
		{
			this.setState({redirect:2});
		}
	}

	renderRedirect()
	{
		let topic_id = sessionStorage.getItem('topic_id');
		if (this.state.redirect===1) {
			return <Redirect to="topics"/>
		}
		else if(this.state.redirect===2)
		{
			return <Redirect to='/donate' />
		}
	}

	render()
	{
		return (
			<React.Fragment>
				{this.renderRedirect()}
				<div className="content-box-area danke-area">
				<div className="default-heading">
				<h2>{this.state.translation.play_again_v1}</h2>
				</div>
				<div className="paragraph-area">
				<p>{this.state.translation.play_again_v4}</p>
				</div>
				<div className="text-center buttons-area">
					<Link to="#" onClick={this.confirmPlayAgain} data-value="yes"><button className="btn btn-primary">{this.state.translation.play_again_v2}</button></Link>
				</div>
				<div className="text-center buttons-area">
					<Link to="#" onClick={this.confirmPlayAgain} data-value="no"><button className="btn btn-primary">{this.state.translation.play_again_v3}</button></Link>
				</div>
				</div>
			</React.Fragment>
		);
	}
}

export default PlayAgain